import React, { useState, useEffect } from "react";
import Layout from "../Layout/Layout";
import { Box, CircularProgress, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";

import dictionary from "../../Mobx/Dictionary";
import imageStore from "../../Mobx/Images";

import AiSettings from "../AI/Settings/AiSettings";
import DictionaryTypeSelector from "../Dictionary/Tools/DictionaryTypeSelector";
import NumberOfResults from "../Dictionary/Tools/NumberOfResults";
import SearchForm from "../Dictionary/Tools/SearchForm";
import CardSizeSelector from "./CardSizeSelector";
import FilterDictionaryByAdditionalInfo from "../AI/Tools/FilterDictionaryByAdditionalInfo";
import FilterDictionaryByRange from "../AI/Tools/FilterDictionaryByRange";
import SortFieldSelector from "../Dictionary/Tools/SortFieldSelector";
import ReloadingRamMemory from "../Dictionary/Tools/ReloadingRamMemory";
import DateTimeRangePicker from "../AI/Tools/DateTimeRangePicker";
import ExportToExcel from "../Dictionary/Tools/ExportToExcel";
import KeyboardShortcuts from "../Dictionary/Tools/KeyboardShortcuts";

import ImagePopup from "./ImagePopup";
import ImageList from "./ImageList";

const ImagesPage = observer(() => {
    const [open, setOpen] = useState(false);
    const [selectedWord, setSelectedWord] = useState(null);
    const [data, setData] = useState(dictionary.current.data[dictionary.current.dictionaryType]);
    const [currentIndex, setCurrentIndex] = useState(dictionary.current.value.index);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchImages = async () => {
            setIsLoading(true);
            await imageStore.getImages();
            setIsLoading(false);
        };
        fetchImages();
    }, []);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setData(dictionary.current.data[dictionary.current.dictionaryType]);
            setCurrentIndex(dictionary.current.value.index);
        }, 100);
        return () => clearTimeout(timeout);
    }, []);

    const tools = [
        <AiSettings />,
        <DictionaryTypeSelector />,
        <NumberOfResults />,
        <SearchForm />,
        <CardSizeSelector />
    ];

    const drawerTools = [
        <FilterDictionaryByAdditionalInfo />,
        <FilterDictionaryByRange />,
        <DateTimeRangePicker />,
        <SortFieldSelector />,
        <ExportToExcel />,
        <ReloadingRamMemory />,
        <KeyboardShortcuts />
    ];

    return (
        <Layout tools={tools} drawerTools={drawerTools}>
            <Box sx={{ height: "calc(100vh - 100px)", width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {isLoading ? (
                    <Box textAlign="center">
                        <CircularProgress />
                        <Typography mt={2}>טוען שמות קבצי תמונות...</Typography>
                    </Box>
                ) : (
                    <ImageList
                        data={data}
                        currentIndex={currentIndex}
                        setSelectedWord={setSelectedWord}
                        setOpen={setOpen}
                    />
                )}
            </Box>

            <ImagePopup open={open} onClose={() => setOpen(false)} selectedWord={selectedWord} />
        </Layout>
    );
});

export default ImagesPage;
